import React from "react";
import { useTranslation } from "react-i18next";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQAccordion = ({ compact = false }) => {
  const { t } = useTranslation();
  const items = t("faq.items", { returnObjects: true }) || [];
  const list = compact ? items.slice(0, 5) : items;
  return (
    <section className="section bg-white" data-testid="faq-section">
      <div className="container-x grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-blue">FAQ</p>
          <h2 className="mt-2 font-heading font-extrabold tracking-tighter text-3xl sm:text-4xl text-slate-900">
            {t("faq.title")}
          </h2>
          <p className="mt-4 text-slate-600 leading-relaxed">{t("faq.subtitle")}</p>
        </div>
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {list.map((it, idx) => (
              <AccordionItem key={idx} value={`item-${idx}`} data-testid={`faq-item-${idx}`}>
                <AccordionTrigger className="text-left font-heading font-semibold text-slate-900 text-base sm:text-lg">
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed">{it.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQAccordion;
